/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Side_BothInputs */

const en_us2_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both`)
};

const pt_br2_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois`)
};

const es_419_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos`)
};

const pt_pt2_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os dois`)
};

const fr_fr2_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux`)
};

const de_de2_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide`)
};

const it_it2_profile_editors_pain_side_both = /** @type {(inputs: Profile_Editors_Pain_Side_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrambi`)
};

/**
* | output |
* | --- |
* | "Both" |
*
* @param {Profile_Editors_Pain_Side_BothInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_side_both = /** @type {((inputs?: Profile_Editors_Pain_Side_BothInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Side_BothInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_side_both(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_side_both(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_side_both(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_side_both(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_side_both(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_side_both(inputs)
	return en_us2_profile_editors_pain_side_both(inputs)
});
export { profile_editors_pain_side_both as "profile-editors.pain_side_both" }